import { t } from '../../i18n.es.js';
import React, { useState } from 'react';
import { styled, Currency, ComboImage, LazyImage } from '@teko/ui';
import { space } from 'styled-system';
import { Body, Tag, Caption } from '@teko/ds-foundation';
import { Gift } from '../../Common/Gift/Gift.es.js';
import { CustomLink } from '../../Common/CustomLink/CustomLink.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const WrapperInfo = styled.div(space);
const StyledCurrency = styled(Currency)`
  font-weight: bold;
`;
const StyledTextCurrency = styled.span`
  width: max-content;
  display: inline-block;
  font-weight: bold;
`;
const StyledGift = styled(Gift)`
  margin: 0.5rem 0;
`;
const GiftBlock = styled.div`
  margin-left: 3rem;
`;
const Wrapper = styled.div`
  display: flex;
`;
const Right = styled.div`
  flex: 1;
  margin-left: 1rem;
`;
const ListedPrice = styled(Currency)(({ lineThrough, theme, size, horizontal }) => `
  text-decoration: ${lineThrough ? "line-through" : "none"};
  color: ${theme.colors.gray130};
  font-size: ${size === "md" ? "0.75rem" : "1.25rem"};
  margin-left: ${horizontal ? "6px" : ""};
`);
const DiscountWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const StrikeThroughPrice = styled.div(({ theme }) => {
  return `
  text-decoration: line-through;
  color: ${theme == null ? void 0 : theme.colors.gray130};
  font-size: 0.75rem;
`;
});
const ItemNote = styled.div(({ maxHeight, line, expanded, theme }) => {
  return `
  display: -webkit-box;
  -webkit-line-clamp: ${expanded ? "unset" : line};
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
  max-height: ${expanded ? "fit-content" : maxHeight};
  width: 100%;
  line-height: 1.5em;
  white-space: normal;
  font-style: italic;
  color: ${theme.colors.neutral};
  word-break: break-word;
  overflow-wrap: break-word;
  padding-right: 0.25em;
`;
});
const ProductCheckoutInfo = (_a) => {
  var _b = _a, {
    imageUrl,
    name,
    quantity,
    price,
    unitPrice,
    gifts,
    targetPath,
    disableProductPromo,
    consultationServiceFee = 0,
    comboImages = [],
    tags,
    displayPrice,
    sku,
    attributeDescription,
    strikeThroughDisplayPrice,
    formatNumber,
    note,
    displayTotalAvailable
  } = _b, props = __objRest(_b, [
    "imageUrl",
    "name",
    "quantity",
    "price",
    "unitPrice",
    "gifts",
    "targetPath",
    "disableProductPromo",
    "consultationServiceFee",
    "comboImages",
    "tags",
    "displayPrice",
    "sku",
    "attributeDescription",
    "strikeThroughDisplayPrice",
    "formatNumber",
    "note",
    "displayTotalAvailable"
  ]);
  const [expanded, setExpanded] = useState(false);
  return /* @__PURE__ */ React.createElement(WrapperInfo, __spreadValues({}, props), /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("div", null, comboImages.length > 0 ? /* @__PURE__ */ React.createElement(ComboImage, {
    images: comboImages
  }) : /* @__PURE__ */ React.createElement(LazyImage, {
    height: 80,
    width: 80,
    borderRadius: 4,
    contain: true,
    border: true,
    src: imageUrl,
    alt: "product"
  })), /* @__PURE__ */ React.createElement(Right, null, !!targetPath ? /* @__PURE__ */ React.createElement(CustomLink, {
    targetPath,
    targetType: "_blank",
    passHref: true
  }, /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    color: "textPrimary",
    weight: "regular",
    line: 2,
    hoverColor: "primary500"
  }, !!tags && tags.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag, {
    type: "secondary",
    variant: "branding",
    content: tags[0]
  }), "\xA0"), name)) : /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    color: "textPrimary",
    weight: "regular",
    line: 2,
    hoverColor: "primary500"
  }, !!tags && tags.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag, {
    type: "secondary",
    variant: "branding",
    content: tags[0]
  }), "\xA0"), name), !!displayTotalAvailable && /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    color: "warning"
  }, displayTotalAvailable), !!attributeDescription && /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    color: "textSecondary"
  }, attributeDescription), /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    color: "textSecondary"
  }, t("S\u1ED1 l\u01B0\u1EE3ng"), " ", quantity), !!sku ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledCurrency, {
    value: price,
    formattedValue: formatNumber ? formatNumber(price) : void 0
  }), unitPrice && unitPrice !== price - consultationServiceFee && /* @__PURE__ */ React.createElement(DiscountWrapper, null, /* @__PURE__ */ React.createElement(ListedPrice, {
    horizontal: false,
    size: "md",
    value: unitPrice,
    lineThrough: true
  })), strikeThroughDisplayPrice && /* @__PURE__ */ React.createElement(DiscountWrapper, null, /* @__PURE__ */ React.createElement(StrikeThroughPrice, null, strikeThroughDisplayPrice))) : /* @__PURE__ */ React.createElement(StyledTextCurrency, null, displayPrice))), /* @__PURE__ */ React.createElement(Wrapper, null, !!gifts.length && /* @__PURE__ */ React.createElement(GiftBlock, null, gifts.map((gift, index) => /* @__PURE__ */ React.createElement(StyledGift, {
    key: index,
    image: {
      src: gift.imageUrl,
      height: 16,
      width: 16
    },
    border: false,
    text: gift.name
  })))), !!note && /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(ItemNote, {
    maxHeight: "4.5em",
    expanded,
    line: 3,
    onClick: () => setExpanded(!expanded)
  }, `${t("Ghi ch\xFA")}: ${note}`)));
};

export { ProductCheckoutInfo };
